export const REFRESH_PARAMETER = "_admin_refresh";
export const REFRESH_PAGE = "refresh-panel.html";
const appBase = () => new URL(`${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/`, window.location.origin);

async function clearAppCaches() {
  const base = appBase();
  const htmlPaths = new Set([base.pathname, `${base.pathname}index.html`, window.location.pathname,
    `${base.pathname}asset-manifest.json`, `${base.pathname}manifest.json`, `${base.pathname}${REFRESH_PAGE}`]);
  const clearStorage = async () => {
    if (!window.caches) return;
    const names = await window.caches.keys();
    await Promise.allSettled(names.map(async (name) => {
      const cache = await window.caches.open(name);
      const requests = await cache.keys();
      await Promise.allSettled(requests.filter((request) => {
        const url = new URL(request.url);
        return url.origin === base.origin && (htmlPaths.has(url.pathname) || url.pathname.startsWith(`${base.pathname}static/`));
      }).map((request) => cache.delete(request)));
    }));
  };
  const removeWorker = async () => {
    if (!navigator.serviceWorker?.getRegistrations) return;
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.allSettled(registrations.filter((registration) => {
      const worker = registration.active || registration.waiting || registration.installing;
      if (!worker) return false;
      const script = new URL(worker.scriptURL);
      return registration.scope === base.href && script.origin === base.origin && script.pathname.startsWith(base.pathname);
    }).map((registration) => registration.unregister()));
  };
  // Cache Storage and HTTP cache are separate. The independent refresh page below
  // requests fresh HTML and changes asset URLs to bypass the mobile HTTP cache too.
  await Promise.allSettled([clearStorage(), removeWorker()]);
}

export async function refreshApp({ signal, navigate = (url) => window.location.replace(url) } = {}) {
  let timeout;
  try {
    await Promise.race([
      clearAppCaches(),
      new Promise((resolve) => { timeout = setTimeout(resolve, 6000); }),
    ]);
  } finally {
    clearTimeout(timeout);
  }
  if (signal?.aborted) return;
  const current = new URL(window.location.href);
  current.searchParams.delete(REFRESH_PARAMETER);
  const destination = new URL(REFRESH_PAGE, appBase());
  destination.searchParams.set("returnTo", current.pathname + current.search + current.hash);
  destination.searchParams.set(REFRESH_PARAMETER, `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
  navigate(destination.href);
}

export function removeRefreshMarker() {
  const url = new URL(window.location.href);
  if (url.searchParams.has(REFRESH_PARAMETER)) {
    url.searchParams.delete(REFRESH_PARAMETER);
    window.history.replaceState(window.history.state, "", url.href);
  }
}
